// extracted by mini-css-extract-plugin
export default {"col":"O72SZ","wrapperRegular":"jgt2s","wrapperMedium":"pEtTy","wrapperBig":"K4nLC"};